<template>
  <div>
    <Modal
      class="modal-unpaid-orders-alert"
      :visible="isVisible"
      size-sm
      :hide-on-click-outside="false"
      @handle="handle">
      <div class="flex flex-col gap-8">
        <i class="fa-solid fa-times text-lg absolute top-0 right-0 p-3 cursor-pointer" @click="isVisible = false" />
        <div class="flex gap-4">
          <i class="fa-solid fa-circle-exclamation text-red text-[68px]"> </i>
          <h5 class="text-3xl pr-4">{{ t('my_orders.you_have_unpaid_orders') }}</h5>
        </div>
        <Button @click="onButtonClick">{{ t('my_orders.pay') }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts" setup>
import { useIdentity } from '~/store/identity'
import Modal from '~/components/Modal.vue'
import { useLang } from '~/composables/useLang'
import { Routes } from '~/enums/Routes'
import { PagesPrefixEnum } from '~/enums/PagesPrefixEnum'

const { t } = useLang()

const route = useRoute()

const identity = useIdentity()

const user = computed(() => {
  return identity.user
})
const hasBeenManuallyClosed = ref(false)
const isVisible = ref(false)

const handle = (value: boolean) => {
  hasBeenManuallyClosed.value = true
  isVisible.value = value
}

const blockedRoutes = [
  Routes.Account.MyOrders,
  Routes.CreateOrderSlug,
  Routes.OrderSuccessful,
  Routes.Checkout.Success,
  Routes.Checkout.SuccessSlug,
  Routes.Checkout.Payment,
  Routes.Checkout.PaymentSlug,
  Routes.Checkout.Confirm,
  Routes.Checkout.ConfirmSlug,
  Routes.Checkout.Shipping,
  Routes.Checkout.ShippingSlug,
  Routes.Reservation.Success,
  Routes.Account.MyOrdersSlug,
  Routes.Account.AccountInformation,
  Routes.Account.DeliveryAddresses,
  Routes.Account.SitePro,
  Routes.Account.SiteProDelivery,
  Routes.Account.SiteProPaymentId,
  Routes.Payment.Accept,
  Routes.SuccessSlug,
]

const matchBlockedRoute = (currentRoute: string) => {
  const matched = blockedRoutes.findIndex((route) => currentRoute === `${PagesPrefixEnum}${route}`)

  return matched !== -1
}
watch(
  user,
  (userData, oldValue) => {
    if (
      userData !== null &&
      userData?.id !== oldValue?.id &&
      userData?.unpaid_orders_count &&
      !hasBeenManuallyClosed.value &&
      !matchBlockedRoute(route.name as string)
    ) {
      isVisible.value = true
    }
  },
  {
    immediate: true,
  }
)

const onButtonClick = () => {
  isVisible.value = false
  hasBeenManuallyClosed.value = true

  navigateTo({
    name: Routes.Account.MyOrders,
    query: { focus_order_table: 'true' },
  })
}
</script>

<style lang="postcss">
.modal-unpaid-orders-alert {
  @apply !max-w-[420px] self-center relative flex-grow-0 !rounded-2xl alt:!rounded-md;

  .modal {
    @apply justify-center rounded-2xl alt:!rounded-md;
  }

  button {
    @apply bg-red !transition-none;

    &:focus-visible {
      @apply !outline-transparent;
    }
  }
}
</style>

<style lang="postcss" scoped>
.wl .modal-unpaid-orders-alert {
  button {
    @apply bg-brand-primary;
  }

  i {
    @apply text-brand-primary;
  }
}
</style>
